import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LandingHeader from "../../components/LandingHeader/Header";
import LandingFooter from "../../components/footer/LandingFooter";
import { contentContext } from "../../context/contentContext";


const MarketPlace = () => {
    const [config, setConfig] = useState({});
    const { menus, setContentSearchFlag, inactiveFlag, setInactiveFlag, contentSearchFlag, clientData, setClientData, setRoute } = useContext(contentContext);
    const navigate = useNavigate();
    let img = window.app.img;
    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);



    if (config.common && config.common.imagesCDN) {
        img = config.common.imagesCDN;
    }
    const handleAll = () => {
        navigate("/faq");
        window.scrollTo(0, 0);
    }

    const handleClick = () => {
        navigate("/signup")
    }
    return (
        <>
            <LandingHeader />

            <section className="production-hero-section ">
                <div className="production-hero-bg">
                    <img src={`${img}orasi/client/resources/orasiv1/images/f6da0913b6ca7aa036c7825ebecec69dc44ec127.png`} alt="Background"
                        className="production-bg-img" />
                </div>

                <div className="container-fluid production-hero-container">
                    <div className="production-hero-content d-flex flex-column align-items-center text-center justify-content-center">
                        <div className="production-hero-text-wrapper">
                            <p className="production-hero-subtitle" data-aos="fade-up" data-aos-duration="1000">MarketPlace</p>
                            <h1 className="production-hero-title" data-aos="fade-up" data-aos-duration="1400">The world's catalog,at your fingertips</h1>
                            <p className="production-hero-description" data-aos="fade-up" data-aos-duration="1800">
                                License 500,000+ hours of content and 300+ global channels — all in one secure marketplace built for broadcasters and platforms.
                            </p>
                        </div>

                        <button className="custom-btn-primary " id="explore-marketplace-button" onClick={handleClick} data-aos="fade-up" data-aos-duration="2200">
                            Explore Marketplace
                            <span className="material-icons">north_east</span>
                        </button>
                    </div>
                </div>
            </section>

            <section className="challenge-solution-section ">
                <div className="container-fluid challenge-solution-container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1000">
                                <div className="card-header-icon" >
                                    <span className="material-symbols-outlined">target</span>
                                    <h3>The Challenge</h3>
                                </div>
                                <p>Content acquisition is slow, fragmented, and tied up in catalogs and emails. Buyers waste time; sellers lose deals.</p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1400">
                                <div className="card-header-icon">
                                    <span className="material-symbols-outlined">star</span>
                                    <h3>The Solution</h3>
                                </div>
                                <p>Our marketplace brings content and channels together with secure transactions, metadata management, and instant access.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="production-features-section ">
                <div className="container-fluid production-features-container">
                    <div className="features-header" data-aos="fade-up" data-aos-duration="1000">
                        <h2>Inside the marketplace</h2>
                    </div>

                    <div className="features-grid">
                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1000">
                            <div className="feature-image" >
                                <img src={`${img}orasi/client/resources/orasiv1/images/marketplace-img-1.png`} alt="Real-Time Budgets" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>300+ Channels Worldwide</h4>
                                <p>FAST, linear, and live channels.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1400">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/marketplace-img-2.png`} alt="AI Assistance" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>500,000+ Hours of Content</h4>
                                <p>Formats, movies, series, documentaries, kids, lifestyle, music.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1800">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/marketplace-img-3.png`} alt="Tool Integrations" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Metadata & Catalog Tools</h4>
                                <p>Simplify search, rights, and licensing.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="2200">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/marketplace-img-4.png`} alt="Storyboard in Seconds" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Global Reach</h4>
                                <p>Multi-language, multi-market access.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="target-audience-section ">
                <div className="container-fluid target-audience-container">
                    <div className="target-audience-card" data-aos="fade-up" data-aos-duration="1000">
                        <div className="row g-0" >
                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>Who is this for?</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Broadcasters & OTTs looking for fast, reliable acquisition.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Content Owners monetizing titles globally.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Regional distributors expanding reach.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>By the number</h3>
                                    <div className="target-list">
                                        <div className="metric-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>300+ global channels already live.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>20+ countries connected through Orasi’s marketplace.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>Hundreds of thousands of hours available across genres.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="production-cta-section ">
                <div className="production-cta-bg"></div>

                <div className="container production-cta-container">
                    <div className="production-cta-content d-flex flex-column align-items-center text-center justify-content-center">
                        <p className="cta-subtitle" data-aos="fade-up" data-aos-duration="1000">Get Started</p>
                        <h2 className="cta-title" data-aos="fade-up" data-aos-duration="1400">
                            Discover. License. Broadcast.
                            {/* <br className="d-none d-md-block" />
        storytelling? */}
                        </h2>

                        <button className="custom-btn-primary" id="browse-content-button" data-aos="fade-up" data-aos-duration="1800" onClick={handleClick}>
                            Browse Content
                            <span className="material-icons">arrow_forward</span>
                        </button>
                    </div>
                </div>
            </section>

            <section className="faq-section">
                <div className="container-fluid faq-container">
                    <div className="faq-header">
                        <h2>Frequently Asked Questions</h2>
                    </div>

                    <div className="faq-list" id="faqAccordion">

                        {/* FAQ 1 */}
                        <div className="faq-item">
                            <div
                                className="faq-question"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq1"
                            >
                                <h4>How do I search on the marketplace?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div
                                id="faq1"
                                className="collapse show"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>You can search in two ways:</p>
                                    <ul>
                                        <p><strong>Basic Search:</strong> Use the search bar at the top to look for titles by name.</p>
                                        <p>
                                            <strong>Advanced Search (recommended):</strong> Filter by Category, Title, Genre, Language,
                                            Available Territories, Rights Type, Video Format, and Release Year to refine your results.
                                        </p>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 2 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq2"
                            >
                                <h4>How do I make an enquiry about a title?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq2" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        If you're interested in a title, add it to your Cart and click <strong>Enquire</strong>.
                                        A form will appear requesting additional details. Once submitted, our team will respond via
                                        email or called shortly.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 3 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq3"
                            >
                                <h4>How do I save or shortlist titles I like?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div
                                id="faq3"
                                className="collapse"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>
                                        You can save titles for later or prepare to enquire by clicking the Cart icon
                                        to add them to your Cart.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 4 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq4"
                            >
                                <h4>Who are the buyers and sellers?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div
                                id="faq4"
                                className="collapse"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>
                                        Our client base includes broadcasters, streaming platforms, channel networks,
                                        studios, production houses, individual producers, and distributors from around the world.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 5 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq5"
                            >
                                <h4>Can I directly buy content or contact a buyer/seller?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div
                                id="faq5"
                                className="collapse"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>
                                        Direct transactions are not available on the platform.
                                        To purchase content, please submit an enquiry and our team
                                        will assist you with the next steps.
                                    </p>
                                </div>
                            </div>
                        </div>

                       


                       
                        <div className="d-flex justify-content-end align-items-center">
                            <a className="anchor-txt" onClick={handleAll}>View All<span className="material-icons">chevron_right</span></a>
                        </div>
                        {/* ONLY chevron_right icon everywhere */}
                    </div>
                </div>
            </section>

            <LandingFooter menus={menus} />
        </>
    );
};

export default MarketPlace;
